function o(e) {
  return !e || e == null || e === "";
}
function u(e) {
  return o(e) ? !1 : /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);
}
function l(e, t) {
  let n = null;
  return (...r) => {
    n && clearTimeout(n), n = setTimeout(() => e(...r), t);
  };
}
function f(e, t) {
  const r = e.getRootNode().host, s = r.querySelector(`[slot="${t}"]`);
  if (s)
    return s.firstChild;
  {
    const i = document.createElement("div");
    i.slot = t, r.appendChild(i);
    const c = document.createElement("div");
    return i.appendChild(c), c;
  }
}
const a = {
  "american express": "amex"
};
function p(e) {
  if (o(e)) return "";
  const t = e.trim().toLowerCase();
  return a[t] || t;
}
function d(e) {
  return o(e) ? "" : `•••• •••• •••• ${e}`;
}
function E(e, t = {}) {
  window.OFFSET && window.OFFSET.analytics && window.OFFSET.analytics.trackEvent(e, t);
}
function g(e) {
  function t(r) {
    return r.replace(/([.*+?\^$(){}|\[\]\/\\])/g, "\\$1");
  }
  var n = document.cookie.match(
    RegExp("(?:^|;\\s*)" + t(e) + "=([^;]*)")
  );
  return n ? n[1] : null;
}
function I(e, t, n) {
  e = e.toString(), e.length === 1 && (e = `0${e}`), t = t.toString(), t.length === 1 && (t = `0${t}`), parseInt(t, 10) > 12 ? t = "12" : parseInt(t, 10) < 1 && (t = "01");
  const r = new Date(
    parseInt(n.toString(), 10),
    parseInt(t, 10),
    0
  ).getDate();
  return parseInt(e, 10) > r ? e = r : parseInt(e, 10) < 1 && (e = "01"), [e, t, n];
}
export {
  f as a,
  u as b,
  p as c,
  l as d,
  I as e,
  g,
  o as i,
  d as m,
  E as t
};
